import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl mt-3 gorda-topnav",
  id: "navbarBlur"
}
const _hoisted_2 = { class: "container-fluid py-1 px-3" }
const _hoisted_3 = {
  class: "collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4 d-flex align-items-center justify-content-between",
  id: "navbar"
}
const _hoisted_4 = { class: "d-flex align-items-center gorda-topnav-left" }
const _hoisted_5 = { class: "gorda-topnav-heading" }
const _hoisted_6 = { class: "gorda-topnav-breadcrumb" }
const _hoisted_7 = { class: "gorda-topnav-breadcrumb-root" }
const _hoisted_8 = { class: "gorda-topnav-breadcrumb-tail" }
const _hoisted_9 = { class: "gorda-topnav-title" }
const _hoisted_10 = { class: "navbar-nav justify-content-end align-items-center" }
const _hoisted_11 = { class: "nav-item d-flex align-items-center me-3" }
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = { class: "nav-item d-flex align-items-center" }
const _hoisted_14 = ["src"]

import {computed} from 'vue'
import {useRoute} from 'vue-router'
import {useI18n} from 'vue-i18n'
import {storeToRefs} from 'pinia'
import {useThemeStore} from '@/services/stores/ThemeStore'
import {useStorage} from '@/services/stores/Storage'


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const theme = useThemeStore()
const isDark = computed(() => theme.isDark)
const toggleTheme = () => theme.toggle()

const storage = useStorage()
const {logoUrl} = storeToRefs(storage)

const route = useRoute()
const {t, te} = useI18n()

const pageTitle = computed(() => {
  const name = route.name
  if (!name) {
    const metaTitle = route.meta?.title as string | undefined
    return metaTitle || ''
  }
  const fullName = String(name)
  const fullKey = 'routes.' + fullName
  if (te(fullKey)) return t(fullKey)
  const firstSegment = fullName.split('.')[0]
  const firstSegmentKey = 'routes.' + firstSegment
  if (te(firstSegmentKey)) return t(firstSegmentKey)
  const metaTitle = route.meta?.title as string | undefined
  if (metaTitle) return metaTitle
  return fullName
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createStaticVNode("<a href=\"javascript:\" class=\"nav-link d-xxl-none text-body p-0 me-2\" id=\"iconNavbarSidenav\" data-v-1455bbc0><div class=\"sidenav-toggler-inner\" data-v-1455bbc0><em class=\"sidenav-toggler-line\" data-v-1455bbc0></em><em class=\"sidenav-toggler-line\" data-v-1455bbc0></em><em class=\"sidenav-toggler-line\" data-v-1455bbc0></em></div></a>", 1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('common.breadcrumb.root')), 1),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gorda-topnav-breadcrumb-sep" }, "/", -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(pageTitle.value), 1)
            ]),
            _createElementVNode("h6", _hoisted_9, _toDisplayString(pageTitle.value), 1)
          ])
        ]),
        _createElementVNode("ul", _hoisted_10, [
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("button", {
              class: "gorda-topnav-icon-chip",
              type: "button",
              "aria-label": isDark.value ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro',
              onClick: toggleTheme
            }, [
              _createElementVNode("em", {
                class: _normalizeClass(isDark.value ? 'fas fa-sun' : 'fas fa-moon'),
                "aria-hidden": "true"
              }, null, 2)
            ], 8, _hoisted_12)
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("img", {
              src: _unref(logoUrl),
              class: "gorda-topnav-avatar",
              alt: "branch logo"
            }, null, 8, _hoisted_14)
          ])
        ])
      ])
    ])
  ]))
}
}

})